const IST = 'Asia/Kolkata';

/** YYYY-MM-DD in Asia/Kolkata */
export const toDayKey = (date = new Date()) => {
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleDateString('en-CA', { timeZone: IST });
};

export const todayKey = () => toDayKey(new Date());

export const yesterdayKey = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return toDayKey(d);
};

/** Last N calendar days ending today (IST), newest first */
export const recentDayKeys = (count = 14) => {
  const keys = [];
  const d = new Date();
  for (let i = 0; i < count; i += 1) {
    keys.push(toDayKey(d));
    d.setDate(d.getDate() - 1);
  }
  return keys;
};

export const orderDayKey = (order) => {
  const t = order?.createdAt?.toDate?.();
  return t ? toDayKey(t) : null;
};

export const deliveredOrderDayKey = (order) => {
  const t = order?.deliveredAt?.toDate?.()
    || order?.updatedAt?.toDate?.()
    || order?.createdAt?.toDate?.();
  return t ? toDayKey(t) : null;
};

export const weekStartKey = (dayKey = todayKey()) => {
  const [y, m, d] = dayKey.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  const day = date.getUTCDay();
  const diff = day === 0 ? 6 : day - 1;
  date.setUTCDate(date.getUTCDate() - diff);
  return toDayKey(date);
};

export const isOnOrAfterDay = (dayKey, startKey) => dayKey >= startKey;

export const formatDayLabel = (dayKey) => {
  if (dayKey === todayKey()) return 'Today';
  if (dayKey === yesterdayKey()) return 'Yesterday';
  const [y, m, d] = dayKey.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-IN', {
    weekday: 'short', day: 'numeric', month: 'short', year: 'numeric',
  });
};
